import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ProductLibrarayService } from '../../services/product-libraray.service';
import { NotificationService, DotLoadingServices } from '../../../../core';
import { ProductDTO, ProductionDataDTO } from '../../interface/product-library.entity';
import { TablePaginationComponent } from '../../../../shared/common';
import { ModalService } from '../../../../shared/services/modal.service';

@Component({
  selector: 'app-production-data-view',
  imports: [CommonModule, FormsModule, TablePaginationComponent],
  templateUrl: './production-data-view.html',
  styleUrl: './production-data-view.scss'
})
export class ProductionDataView {

  protected router = inject(Router);
  protected productLibraryService = inject(ProductLibrarayService);
  protected notification = inject(NotificationService);
  protected modal = inject(ModalService);
  private loading = inject(DotLoadingServices);

  totalItems = signal<number>(0);
  pageNumber = signal<number>(1);
  itemsPerPage = signal<number>(10);
  products = signal<ProductDTO[]>([]);
  selectedProduct = signal<ProductDTO | null>(null);
  productionData = signal<ProductionDataDTO | null>(null);

   protected searchParams = signal({
      pageNumber: 1,
      itemsPerPage: 10,
      productCode: ''
  });
  

  ngOnInit() {
    this.getAllProducts();
  }

  getAllProducts() {
    this.loading.set(true);
    this.productLibraryService.getAllProducts(this.searchParams()).subscribe({
      next: (res) => {
        const response = res.data;

        this.products.set(response.data);

        this.totalItems.set(response.pagination.totalItems);
        this.pageNumber.set(response.pagination.pageNumber);
        this.itemsPerPage.set(response.pagination.itemsPerPage);
        this.loading.set(false);

      },
      error: (err) => {
        console.error('Failed to fetch products', err);
        this.loading.set(false);
      }
    });
  }

  public onPageChange(pageNumber: number): void {
    const updatedParams = {
        ...this.searchParams(),
        pageNumber: Number(pageNumber)
    };
    this.searchParams.set(updatedParams);
    this.getAllProducts();
  }

  
  addProductionData(prodCode: string) {
    this.router.navigate(['production-data-add'], {
      queryParams: { code: prodCode }
    });
  }

   openProductionDataEdit(prodCode: string) {
    this.router.navigate(['production-data-add'], {
      queryParams: { code: prodCode, mode: 'edit' }
    });
  }

  openProductionDataView(productCode: string) {
    this.modal.$$showProductionDataModal.set(true);
    this.getProductGetByCode(productCode);
  }

  closeProductionDataModal() {
    this.modal.$$showProductionDataModal.set(false);
  }

  getProductGetByCode(prodCode: string) {
    this.loading.set(true);
    this.productLibraryService.getProductById(prodCode).subscribe({
      next: (res) => {
        this.selectedProduct.set(res.data);
        this.productionData.set(res.data.productionData ?? null)
        this.loading.set(false);
      },
      error: (err) => {
        console.error('Failed to fetch product by ID', err);
        this.loading.set(false);
      }
    });
  }

}
